import { formatReportMoneyFa, formatReportNumberFa } from '../../../pages/reports/chartFormatters';
import { toNumber } from '../../../pages/reports/reportUtils';

/**
 * استخراج متن‌های آماده فاصله تا هدف و نیاز روزانه از پاسخ API
 * (با fallback محاسباتی اگر بک‌اند هنوز متن نفرستد)
 */
export const resolveGoalPaceInfo = (source = {}, { key, period } = {}) => {
  const goalKey = key || source.key || 'revenue';
  const gap = Math.max(0, toNumber(source.gap != null ? source.gap : source.gap_amount));
  const dailyNeeded = toNumber(source.daily_needed);
  const workingDays =
    toNumber(source.working_days_remaining) ||
    toNumber(period?.working_days_remaining) ||
    toNumber(period?.days_remaining);

  let gapText = source.gap_text || source.gap_formatted || null;
  let dailyRequirementText = source.daily_requirement_text || null;
  let dailyNeededFormatted = source.daily_needed_formatted || null;

  if (!gapText && gap > 0) {
    if (goalKey === 'revenue') {
      gapText = `${formatReportMoneyFa(gap)} باقیمانده`;
    } else if (goalKey === 'deals') {
      gapText = `${formatReportNumberFa(gap)} معامله باقیمانده`;
    } else if (goalKey === 'calls') {
      gapText = `${formatReportNumberFa(gap)} تماس باقیمانده`;
    } else if (goalKey === 'followups') {
      gapText = `${formatReportNumberFa(gap)} پیگیری باقیمانده`;
    } else {
      gapText = `${formatReportNumberFa(gap)} باقیمانده`;
    }
  }

  if (!dailyNeededFormatted && dailyNeeded > 0) {
    dailyNeededFormatted =
      goalKey === 'revenue'
        ? formatReportMoneyFa(dailyNeeded)
        : formatReportNumberFa(Number(dailyNeeded.toFixed(1)));
  }

  if (!dailyRequirementText && gap > 0) {
    if (goalKey === 'revenue') {
      const perDay =
        dailyNeeded > 0
          ? dailyNeeded
          : workingDays > 0
            ? gap / workingDays
            : gap;
      dailyRequirementText = `برای رسیدن به هدف باید به‌طور متوسط روزانه ${formatReportMoneyFa(perDay)} فروش داشته باشید.`;
    } else if (goalKey === 'deals') {
      dailyRequirementText = `تا پایان ماه به ${formatReportNumberFa(gap)} معامله موفق دیگر نیاز دارید.`;
    } else if (goalKey === 'calls') {
      const perDay =
        dailyNeeded > 0
          ? Math.ceil(dailyNeeded)
          : workingDays > 0
            ? Math.ceil(gap / workingDays)
            : gap;
      dailyRequirementText = `روزانه حداقل ${formatReportNumberFa(perDay)} تماس دیگر لازم است.`;
    } else if (goalKey === 'followups') {
      const perDay =
        dailyNeeded > 0
          ? Math.ceil(dailyNeeded)
          : workingDays > 0
            ? Math.ceil(gap / workingDays)
            : gap;
      dailyRequirementText = `روزانه حداقل ${formatReportNumberFa(perDay)} پیگیری دیگر لازم است.`;
    }
  }

  return {
    gap,
    gapText: gap > 0 ? gapText : null,
    dailyNeeded,
    dailyNeededFormatted: dailyNeeded > 0 || gap > 0 ? dailyNeededFormatted : null,
    dailyRequirementText: gap > 0 ? dailyRequirementText : null,
    workingDaysRemaining: workingDays > 0 ? workingDays : null,
  };
};

/** بلوک UI فشرده برای نمایش فاصله تا هدف + نیاز روزانه */
export const GoalPaceCallout = ({
  gapText,
  dailyRequirementText,
  workingDaysRemaining,
  className = '',
  compact = false,
}) => {
  if (!gapText && !dailyRequirementText) return null;

  return (
    <div
      className={`w-full min-w-0 rounded-xl border border-amber-200/90 dark:border-amber-800/50 bg-amber-50/90 dark:bg-amber-950/25 ${
        compact ? 'px-2.5 py-2' : 'px-3 py-2.5'
      } ${className}`}
    >
      {gapText ? (
        <div
          className={`custom-font font-semibold text-amber-800 dark:text-amber-200 tabular-nums break-words ${
            compact ? 'text-[12px]' : 'text-[13px]'
          }`}
        >
          {gapText}
        </div>
      ) : null}
      {dailyRequirementText ? (
        <div
          className={`custom-font text-amber-700/90 dark:text-amber-300/90 leading-relaxed break-words ${
            compact ? 'text-[11px] mt-1' : 'text-[12px] mt-1.5'
          }`}
        >
          {dailyRequirementText}
        </div>
      ) : null}
      {workingDaysRemaining != null && workingDaysRemaining > 0 ? (
        <div className="custom-font text-[10px] text-amber-600/80 dark:text-amber-400/70 mt-1 tabular-nums">
          {formatReportNumberFa(workingDaysRemaining)} روز کاری باقی‌مانده
        </div>
      ) : null}
    </div>
  );
};
